export default "__VITE_ASSET__DGfCJkoB__"